import { FC, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { ISemester } from '../../../models/semesters.model';
import _ from 'lodash';
import { Table, TableColumnsType } from 'antd';
import Loader from '../../Loader';
import moment from 'moment';
import DownloadButton from '../../DownloadButton';
import Pagination from '../../Pagination';
import config from '../../../lib/config';
import exportTable from '../../../lib/exportTable';
import { getCommonCodeLabel } from '../../../lib/store';

interface IProps {
  semesters: any;
  semesterData: any;
  monthInputInit: any;
  setMonthInput: any;
  onSetSemester: any;
  getSemesterMonths: any;
  getSemesterCourses: any;
  setChosenCourse: any;
  param: any;
  page: any;
  semesterCode: string;
  setSemesterCode: (semesterCode: string) => void;
  setSelSemesterType: (semesterType: string) => void;
}

const SemesterTable: FC<IProps> = ({
  semesters,
  semesterData,
  monthInputInit,
  setMonthInput,
  onSetSemester,
  getSemesterMonths,
  getSemesterCourses,
  setChosenCourse,
  param,
  page,
  semesterCode,
  setSemesterCode,
  setSelSemesterType
}) => {
  const { t, i18n } = useTranslation();
  const [exportTableLoading, setExportTableLoading] = useState(false);

  const onExportTable = () => {
    setExportTableLoading(true);
    const data = _.cloneDeep(semesterData);
    data.forEach((semester: any) => {
      // 유형 열 변환
      semester.semesterType = getCommonCodeLabel('PR0002', semester.semesterType, 'ko');
    });
    const currentDate = moment(new Date());
    exportTable(columns, data, `${t('program.semester.title1')}_(${currentDate.format('YYYYMMDD')})`, `${t('program.semester.title1')}`, [25, 10] );
    setExportTableLoading(false);
  }

  const columns: TableColumnsType<ISemester> = [
    {
      title: t('common.column.semester'),
      dataIndex: 'semesterName',
      key: 'semesterName',
      sorter: (a, b) => a.semesterName?.localeCompare(b.semesterName),
      align: 'center'
    },
    {
      title: t('program.semester.column12'),
      dataIndex: 'semesterSrtDate',
      key: 'semesterSrtDate',
      sorter: (a, b) => a.semesterSrtDate?.localeCompare(b.semesterSrtDate),
      align: 'center',
      render: (value) => (value) ? moment(value).format('YYYY.MM.DD') : '-'
    },
    {
      title: t('program.semester.column13'),
      dataIndex: 'semesterEndDate',
      key: 'semesterEndDate',
      sorter: (a, b) => a.semesterEndDate?.localeCompare(b.semesterEndDate),
      align: 'center',
      render: (value) => (value) ? moment(value).format('YYYY.MM.DD') : '-'
    },
    {
      title: t('program.semester.column33'),
      dataIndex: 'semesterType',
      key: 'semesterType',
      sorter: (a, b) => a.semesterType?.localeCompare(b.semesterType),
      render: (value: string) => getCommonCodeLabel('PR0002', value, i18n.language),
      align: 'center'
    },
  ];

  return (
    <div>
      {exportTableLoading ? <Loader /> : null}
      <div>
        <div className="comm-bx__between">
          <div className="comm-sch_result">
            {t('common.text.count')}: <b>{semesterData?.length}</b>{t('common.text.unit')}
          </div>
        </div>
        <div className="comm-table__area">
          <Table
            columns={columns}
            dataSource={semesterData || undefined}
            pagination={{
              current: page,
              pageSize: config.middlePageSize
            }}
            onRow={(record: any) => {
              return {
                onClick: () => {
                  setSemesterCode(String(record.semesterCode));
                  setMonthInput(monthInputInit);
                  onSetSemester(record.semesterCode);
                  getSemesterMonths(record.semesterCode);
                  getSemesterCourses(record.semesterCode);
                  setChosenCourse(null);
                  setSelSemesterType(record.semesterType);
                }
              };
            }}
            rowClassName={(record: any) => record.semesterCode === semesterCode ? 'chosen' : 'pointer'}
            rowKey="semesterCode"
          />
        </div>
        <div className="comm-bx__between">
          <div className="comm-btn__area">
            <DownloadButton
              onClick={onExportTable}
            />
          </div>
          <div className="common-paging right">
            <Pagination
              count={semesters?.length || 0}
              page={page}
              param={param}
              perPage={config.middlePageSize}
              path="/program/semester2"
              small
            />
          </div>
        </div>
      </div>
    </div>
  );
}

export default SemesterTable;
